import { MODAL_SIZES, Modal, ModalHeader, ModalBody, ModalFooter, MODAL_VARIANTS } from 'ui/modal';
import { BUTTON_SIZES, DestructiveButton } from 'ui/button';
import { useModalContext } from 'utils/contexts/modal';
import { DCB_MODAL } from '../../types';
import { useDynamicContentContext } from '../../contexts';
import { useTranslation } from '../../hooks/useTranslation';

const DATA_PORTAL_ID = 'dcb-confirmation-modal';

export const ConfirmationModal = () => {
  const { t } = useTranslation();
  const { modalState, hideModal } = useModalContext<DCB_MODAL>();
  const { onClose: onDiscard } = useDynamicContentContext();

  return (
    <Modal
      id="dcb-drawer-confirmation-modal"
      isModalOpen={modalState === DCB_MODAL.Confirmation}
      withPortal
      onClose={hideModal}
      data-portal-id={DATA_PORTAL_ID}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <ModalHeader onClose={hideModal}>{t('modal.confirmation.header')}</ModalHeader>
      <ModalBody>{t('modal.confirmation.body')}</ModalBody>
      <ModalFooter onClose={hideModal}>
        <DestructiveButton onClick={onDiscard} size={BUTTON_SIZES.LARGE}>
          {t('modal.confirmation.discardButton')}
        </DestructiveButton>
      </ModalFooter>
    </Modal>
  );
};
